export default "__VITE_ASSET__B8CQRuH4__"